import React from "react";
import { useTheme } from "../theme/ThemeProvider";

function WomCard({ children, padding = "md", elevated = false, style = {} }) {
  const t = useTheme();

  return (
    <div
      style={{
        background: t.colors.bgElevated,
        borderRadius: t.radius.lg,
        padding: t.spacing[padding],
        boxShadow: elevated ? t.shadow.lg : t.shadow.none,
        border: `1px solid ${t.colors.borderSubtle}`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default WomCard;
export { WomCard };
